module.exports = __webpack_public_path__ + "img/ditu20.ee53d490.png";